import React, { useEffect, useState, useMemo } from 'react'

import { useSelector, useDispatch } from 'react-redux'
import { useParams, useHistory } from 'react-router-dom'
import _ from 'lodash'
import { PurchaseTypes, PurchaseActions } from 'Redux/purchases'
import CircularProgress from '@material-ui/core/CircularProgress'
import { CategoryButton, CategoryHabitualButton } from 'Components/atoms'
import routes from 'Config/routes'
import { needsApprovalMode } from 'Redux/approver/selectors'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { selectConfig } from 'Redux/auth/utils'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import useIsMobile from 'hooks/useIsMobile'

import { SectionContainer, ProviderName, useStyles } from './styled'

const Siderbar = ({ hideSidebar }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const { providerId } = useParams()
  const { pathname } = useLocation()
  const isMobile = useIsMobile()

  const needsApproval = useSelector(needsApprovalMode)

  useEffect(() => {
    if (providerId) dispatch({ type: PurchaseTypes.FETCH_CATEGORIES_PROVIDERS, params: { providerId } })
  }, [dispatch, providerId])

  const isProviderRoute = _.get(history, 'location.pathname', '').includes(routes.providers)
  const isHabitualRoute = _.get(history, 'location.pathname', '').includes(routes.habitualCats)

  const navigate = id => {
    dispatch(PurchaseActions.setShowOnlyOneProducts(false))
    if (isProviderRoute) {
      history.push(routes.addCategoryProvider(providerId, id))
      return
    }
    if (isHabitualRoute) {
      history.push(routes.AddCategoryHabitual(id))
      return
    }
    history.push(routes.AddCategory(id))
  }

  const hidden = useSelector(state => state.auth.hiddenNavbar)
  const categoriesMain = useSelector(state => state.purchase.categories)
  const categoriesHabitual = useSelector(state => state.purchase.categoriesHabitual)
  const providerCategories = useSelector(state => state.purchase.providerCategories)
  const isLoading = useSelector(state => state.purchase.isLoadingCategories)
  const provider = useSelector(state => {
    if (!isProviderRoute) return {}
    // eslint-disable-next-line
    return state.purchase.providers.find(({ id }) => id == providerId) || {}
  })
  const features = useSelector(selectConfig)

  const [selected, setSelected] = useState(0)

  useEffect(() => {
    if (!isHabitualRoute) return
    const routeIndex = categoriesHabitual.findIndex(cat => routes.AddCategoryHabitual(cat.id) === pathname)
    setSelected(routeIndex)
  }, [categoriesHabitual, pathname, isHabitualRoute])

  useEffect(() => {
    dispatch({ type: PurchaseTypes.FETCH_CATEGORIES_HABITUAL })
    if (!isHabitualRoute) {
      setSelected(0)
    }
  }, [isHabitualRoute, dispatch, features])

  let categories
  if (isProviderRoute) categories = providerCategories
  else if (isHabitualRoute) categories = categoriesHabitual
  else categories = categoriesMain

  const filteredCategories = useMemo(() => categories.filter(({ id }) => id !== 'NA'), [categories])

  return (
    <SectionContainer opacity={isLoading ? 0.5 : 1} isHidden={hidden} needsApproval={needsApproval} $tutorial={false}>
      {isProviderRoute ? <ProviderName>{provider.name}</ProviderName> : null}
      {isLoading ? <CircularProgress style={{ position: 'absolute', top: '8rem', left: '43%' }} /> : null}
      {!isHabitualRoute
        ? filteredCategories.map(({ children, id, name }) => (
            <CategoryButton subCategories={children} key={id} id={id} name={name} navigate={navigate} />
          ))
        : null}
      {isHabitualRoute
        ? filteredCategories.map(({ id, name }, index) => (
            <CategoryHabitualButton
              key={id}
              id={id}
              name={name}
              navigate={navigate}
              onClick={() => setSelected(index)}
              selected={index === selected || false}
            />
          ))
        : null}

      {isMobile && (
        <Box position='fixed' bottom={0} width='330px' padding={2}>
          <Button className={classes.button} fullWidth onClick={() => hideSidebar(false)}>
            {t('Mostrar resultados')}
          </Button>
        </Box>
      )}
    </SectionContainer>
  )
}

Siderbar.propTypes = {
  hideSidebar: PropTypes.func,
}

Siderbar.defaultProps = {
  hideSidebar: () => {},
}

export default Siderbar
